import script from "./ClassroomProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomProgram.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomProgram.vue?vue&type=style&index=0&id=1cbe14ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cbe14ba"]])

export default __exports__